import styled from 'styled-components';

const ScoreRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export default ScoreRow;
